import { render, staticRenderFns } from "./FixedPopup.vue?vue&type=template&id=26832146"
import script from "./FixedPopup.vue?vue&type=script&lang=js"
export * from "./FixedPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports